export const filtros = {
  municipio: 1,
  responsavel: 2,
  dataInicial: 3,
  dataFim: 4,
  solucao: 5,
  grupoSolucao: 6,
  grupoUsuario: 7,
  statusRelacionamento: 8,
  radar: 9,
  regional: 10,
  uf: 11,
  eixo: 12,
  tema: 13,
  usuario: 14,
  projeto: 15,
  grupoClienteOculto: 16,
  selo: 17,
};
